export default "__VITE_ASSET__5fToHa_$__"